import React, { useEffect, useState } from "react";
import banner from "assets/img/profile/banner.png";
import UserService from "services/user.service";
import { IoMdClose } from "react-icons/io";
import moment from "moment";
import Avatar from "react-avatar";

const Profile = ({
  profileData,
  isOpen,
  onClose,
  isActive,
  onToggle,
  profileRef,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div
        className="w-[430px] rounded-xl bg-navy-800 px-6 pb-6 shadow-lg"
        ref={profileRef}
      >
        <div className="flex justify-end py-3">
          <IoMdClose className="cursor-pointer text-2xl" onClick={onClose} />
        </div>
        <div
          className="relative mt-1 flex h-32 w-full justify-center rounded-xl bg-cover"
          style={{ backgroundImage: `url(${banner})` }}
        >
          <div className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] !border-navy-700 bg-pink-400">
            {profileData.profileImg ? (
              <img
                src={profileData.profileImg}
                alt="Profile"
                className="h-full w-full rounded-full"
              />
            ) : (
              <Avatar
                name={profileData.email}
                className="h-full w-full rounded-full"
              />
            )}
            {/* <img
              className="h-full w-full rounded-full"
              src={profileData.profileImg}
              alt="Profile"
            /> */}
          </div>
        </div>

        {/* Name and position */}
        <div className="mt-16 flex flex-col items-center">
          <h4 className="text-xl font-bold text-white">
            {profileData.lastName ? profileData.lastName : "--"}
          </h4>
          <p className="text-base font-normal text-gray-600">
            {profileData.email ? profileData.email : "--"}
          </p>
          <p className="text-base font-normal text-gray-600">
            {profileData.mobile ? profileData.mobile : "--"}
          </p>
        </div>

        {/* Post followers */}
        <div className="mb-3 mt-6 flex justify-center gap-4 md:!gap-14">
          <div className="flex flex-col items-center justify-center">
            <p className="text-2xl font-bold capitalize text-white">
              {profileData.gender}
            </p>
            <p className="text-sm font-normal text-gray-600">Gender</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <p className="text-2xl font-bold text-white">
              {moment.utc(profileData.dob).format("DD/MM/YYYY")}
            </p>
            <p className="text-sm font-normal text-gray-600">DOB</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <p className="text-2xl font-bold text-white">
              {profileData.isActive ? "Yes" : "No"}
            </p>
            <p className="text-sm font-normal text-gray-600">Activated</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
